export default __webpack_public_path__ + "static/media/vipul_motors_img.51f62153.png";